import type {
	ActivityLogOut,
	ActivityLogPerformerMetadata,
} from '@repo/api-codegen';

export const USER_PERFORMER_TYPES: ActivityLogOut['performer_type'][] = [
	'USER',
	'API',
];

export interface IActivityLogPerformer {
	id: string;
	type: ActivityLogOut['performer_type'];
	metadata: ActivityLogPerformerMetadata;
}
